import {
    Flex,
    Container,
    Stack,
    useColorModeValue,
    Heading,
    Text,
    Highlight,
    Wrap, 
    WrapItem,
    Image 
} from '@chakra-ui/react'

import theme from '../../../Config/theme'

import { IoTimer, IoLockClosed, IoCard } from 'react-icons/io5'

import visa from '../../../Assets/PaymentMethods/visa.svg'
import mastercard from '../../../Assets/PaymentMethods/mastercard.svg'
import discover from '../../../Assets/PaymentMethods/discover.svg'
import amex from '../../../Assets/PaymentMethods/amex.svg'
import googlepay from '../../../Assets/PaymentMethods/googlepay.svg'
import applepay from '../../../Assets/PaymentMethods/applepay.svg'

const Features = () => {
    const borderColor = useColorModeValue(theme.borderColor.borderColorLight, theme.borderColor.borderColorDark)
    const backgroundColor = useColorModeValue('gray.100', 'gray.800')

    return (
        <Flex
            w={'full'}
            h={'40vg'}
            // pt={5}
            pb={'10vh'}
        >
            <Container
                maxW={'6xl'}
            >
                <Stack
                    direction={{ base: 'column', md: 'column', lg: 'row' }}
                    justify={'space-between'}
                    spacing={10}
                    border={'1px'}
                    borderColor={borderColor}
                    borderRadius={'md'}
                    p={5}
                    bgColor={backgroundColor}
                    
                >
                    <Stack direction={'row'} align={'top'} w={'full'}>
                        <IoTimer size={30} color={'#48BB78'} />
                        <Stack direction={'column'} >
                            <Heading fontSize={'2xl'}>Try it risk-free</Heading>
                            <Text>Unhappy with your purchase? Get a full refund within 30 days. Terms apply.</Text>
                        </Stack>
                    </Stack>

                    <Stack direction={'row'} align={'top'} w={'full'}>
                        <IoLockClosed size={30} color={'#4299E1'} />
                        <Stack direction={'column'} >
                            <Heading fontSize={'2xl'}>Secure payments</Heading>
                            <Text>We use strong data encryption technology to protect your payment information.</Text>
                        </Stack>
                    </Stack>

                    <Stack direction={'row'} align={'top'} w={'full'}>
                        <IoCard size={30} color={'#ED64A6'} />
                        <Stack direction={'column'} >
                            <Heading fontSize={'2xl'}>Accepted payments</Heading>
                            <Wrap>
                                <WrapItem>
                                    <Image src={visa} />
                                </WrapItem>
                                <WrapItem>
                                    <Image src={mastercard} />
                                </WrapItem>
                                <WrapItem>
                                    <Image src={discover} />
                                </WrapItem>
                                <WrapItem>
                                    <Image src={amex} />
                                </WrapItem>
                                <WrapItem>
                                    <Image src={applepay} />
                                </WrapItem>
                                <WrapItem>
                                    <Image src={googlepay} />
                                </WrapItem>
                            </Wrap>
                        </Stack>
                    </Stack>
                </Stack>
            </Container>
        </Flex>
    )
}

export default Features